/**
 * Print guide constants for bleed, trim, and safe zone overlays.
 * All values in CSS pixels at 96 DPI.
 */

const MM_TO_PX = 96 / 25.4; // 1mm = ~3.78px at 96 DPI

export const BLEED_MM = 3;
export const SAFE_ZONE_MM = 6;

export const BLEED_PX = Math.round(BLEED_MM * MM_TO_PX);   // ~11px
export const SAFE_ZONE_PX = Math.round(SAFE_ZONE_MM * MM_TO_PX); // ~23px

export const GUIDE_COLORS = {
  trim: "#ff0000",       // Red - page edge / trim line
  bleed: "#00aaff",      // Blue - 3mm outside trim
  safeZone: "#00cc44",   // Green - 6mm inside trim
};

export const GUIDE_STYLES = {
  trim: { color: GUIDE_COLORS.trim, dashArray: "none", width: 1, label: "Trim" },
  bleed: { color: GUIDE_COLORS.bleed, dashArray: "6,4", width: 1, label: "Bleed (3mm)" },
  safeZone: { color: GUIDE_COLORS.safeZone, dashArray: "4,4", width: 1, label: "Safe Zone (6mm)" },
};
